module.exports = __webpack_public_path__ + "static/media/OurProduct-TanBlock.0750eec1.svg";